export function normalizeSectorName(name?: string): string {
  if (!name) return '';

  let normalized = String(name).trim().toLowerCase();
  const original = normalized;
  const originalNoVipFan = original.replace(/\b(vip\s*[-_ ]?\s*fan|fan\s*vip)\b/gi, '');

  normalized = normalized.replace(/\b(vip\s*[-_ ]?\s*fan|fan\s*vip)\b/gi, '');
  normalized = normalized.replace(/vip suite\s*/g, 'vip suite ');
  normalized = normalized.replace(/vip\s*ложа/g, 'ложа vip');
  normalized = normalized.replace(/ложа\s*vip\s*(\d+)/g, 'ложа vip $1');
  normalized = normalized.replace(/ложа\s*№\s*/g, 'ложа ');
  normalized = normalized.replace(/[–—]/g, '-');
  normalized = normalized.replace(/^(sector|сектор)\s*[:.-]?\s*/i, '');
  normalized = normalized.replace(/\s*\(.*?\)\s*$/, '');
  normalized = normalized.replace(/vip\s*(\d+)/g, 'vip $1');
  normalized = normalized.replace(/\s+/g, ' ').trim();

  const hasSuite = /suite/.test(originalNoVipFan);
  const hasLodge = /ложа/.test(originalNoVipFan);
  const hasVip = /vip/.test(originalNoVipFan);
  const numMatch = normalized.match(/(\d+)/);

  if (numMatch) {
    const num = numMatch[1];
    if (hasVip && hasLodge && hasSuite) {
      return `ложа ${num}`;
    }
    if (hasVip && hasLodge) {
      return `ложа vip ${num}`;
    }
    if (hasLodge) {
      return `ложа ${num}`;
    }
    if (hasVip) {
      return `vip ${num}`;
    }
  }

  return normalized.replace(/\s+/g, ' ').trim();
}
